export default {
  methods: {
    openDialog(ref) {
      this.$refs[ref].open();
    },
    closeDialog(ref) {
      this.$refs[ref].close();
    },
  },
};



// WEBPACK FOOTER //
// ./src/js/mixins/hasDialogs.js